import React from 'react';
import { APP_STORE_URL } from '../constants/urls';

function AppStoreRedirect() {
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.replace(APP_STORE_URL);
    }
  }, []);

  return (
    <section className="app-store-redirect">
      <div className="app-store-redirect__content">
        <h1>Opening the App Store&hellip;</h1>
        <p>If nothing happens, <a href={APP_STORE_URL}>continue to the App Store</a>.</p>
      </div>
    </section>
  );
}

export default AppStoreRedirect;
